import * as React from 'react';
import styled from '@emotion/styled';

const StyledFooter = styled('footer')`
  flex-shrink: 0;
  padding: 1rem 3rem;
  background: rgb(62,62,62);
  color: white;
  text-align: center;
`;

class Footer extends React.PureComponent {
  render () {
    return (
      <StyledFooter>
        <p>
          { new Date().getFullYear() }&nbsp;
          &copy; Copyright claimed on all content herein by Australian Sporting Innovations Pty Ltd.
        </p>
      </StyledFooter>
    );
  }
}

export default Footer;
